import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import messages from './LinkDebitCard.messages';
import styles from './LinkDebitCard.module.css';
import { FormField } from '../../../../forms/formField/index';

export function CardholderNameQuestion() {
    return (
        <div className={styles.field}>
            <FormField
                label={<FormattedMessage {...messages.cardholderName} />}
                className={classNames(styles.cardholderName, 'fs-exclude')}
                name="cardholderName"
                placeholder="John Smith"
            />
        </div>
    );
}
